import { SessionFormContext } from "@modules/sessions/context/sessionFormContext"
import { useContext } from "react"

export const useSessionFormContext = () => {
  const {
    formik,
    isSubmitting,
    program,
    updatedBlockIndex,
    initialUpdatedBlock,
    isEditingBlock,
    editedSlot,
    setEditedSession,
    setEditedSlot,
    setDateSession,
    setProgram,
    setUpdatedBlockIndex,
    setInitialUpdatedBlock,
    setIsEditingBlock,
    moveBlock,
    deleteBlock,
    copyBlock,
    resetForm,
    onHideSessionForm,
    onHideBlockForm,
    onHideChronoForm,
  } = useContext(SessionFormContext)

  return {
    formik,
    isSubmitting,
    program,
    updatedBlockIndex,
    initialUpdatedBlock,
    isEditingBlock,
    editedSlot,
    setEditedSession,
    setEditedSlot,
    setDateSession,
    setProgram,
    setUpdatedBlockIndex,
    setInitialUpdatedBlock,
    setIsEditingBlock,
    moveBlock,
    deleteBlock,
    copyBlock,
    resetForm,
    onHideSessionForm,
    onHideBlockForm,
    onHideChronoForm,
  }
}
